<div class="source-selection">
    <mat-accordion [multi]="true">
        @for (group of groups; track group.key) {
            <mat-expansion-panel
                [expanded]="isGroupExpanded(group)"
                (expandedChange)="setGroupExpanded(group, $event)"
            >
                <mat-expansion-panel-header class="panel-heading">
                    <mat-panel-title class="start-center flex-row">
                        <mat-icon>list</mat-icon>
                        <div class="cb-margin-left-2x flex-col flex">
                            <h1 class="mat-body-strong">{{ group.label }}</h1>
                        </div>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <cb-table class="selection-table cb-margin-top cb-margin-bottom flex" [loaded]="true">
                    <thead cbTableHead>
                        <tr>
                            <td style="width: 48px"></td>
                            <td class="lot-details-column">Lot Details</td>
                            <td class="lot-type-column">Lot Type</td>
                            <td class="job-status-column">Job Status</td>
                            @if (group.key === INELIGIBLE_GROUP_KEY) {
                                <td class="error-message-column">Reason(s) for ineligible migration</td>
                            }
                            @if (group.key !== INELIGIBLE_GROUP_KEY) {
                                <td class="error-message-column"></td>
                            }
                        </tr>
                    </thead>
                    <tbody cbTableBody>
                        @for (row of group.lots; track row.lot.id) {
                            <tr cbTableRow>
                                <td>
                                    @if (group.key === ELIGIBLE_GROUP_KEY) {
                                        <span
                                            class="checkbox-tooltip-host"
                                            [matTooltip]="getDisabledReason(row) || ''"
                                            [matTooltipDisabled]="!getDisabledReason(row)"
                                        >
                                            <mat-checkbox
                                                [checked]="isSelected(row.lot)"
                                                [disabled]="!canSelect(row)"
                                                (change)="handleChecked($event.checked, row)"
                                            ></mat-checkbox>
                                        </span>
                                    } @else {
                                        <div class="checkbox-placeholder"></div>
                                    }
                                </td>
                                <td>
                                    <div class="lot-title">
                                        Lot {{ row.lot.lotNumber }} @if (row.lot.jobNumber) { ( {{ row.lot.jobNumber }} ) }
                                    </div>
                                    <div class="lot-subtitle">{{ row.lot.lotAddress.street }}, {{ row.lot.lotAddress.suburb }}</div>
                                </td>
                                <td>{{ LOT_TYPE_ENUM[row.lot.lotType] }}</td>
                                <td>
                                    <span
                                        class="job-status"
                                        [class]="group.key === ELIGIBLE_GROUP_KEY || row.lot.canBeMigrated ? 'job-status-eligible' : 'job-status-ineligible'"
                                    >
                                        {{ LOT_JOB_STATUS_ENUM[row.lot.jobStatus] }}
                                    </span>
                                </td>
                                @if (group.key === INELIGIBLE_GROUP_KEY) {
                                    <td>
                                        @for (reason of getDisplayReasons(row.lot); track reason) {
                                            <div class="eligibility-reason">{{ reason }}</div>
                                        }
                                    </td>
                                }
                                @if (group.key !== INELIGIBLE_GROUP_KEY) {
                                    <td></td>
                                }
                            </tr>
                            @for (childLot of row.childLots; track childLot.id) {
                                <tr cbTableRow class="child-row">
                                    <td></td>
                                    <td>
                                        <div class="lot-title">
                                            Unit {{ childLot.lotNumber }} @if (childLot.jobNumber) { ( {{ childLot.jobNumber }} ) }
                                        </div>
                                        <div class="lot-subtitle">{{ childLot.lotAddress.street }}, {{ childLot.lotAddress.suburb }}</div>
                                    </td>
                                    <td>{{ LOT_TYPE_ENUM[childLot.lotType] }}</td>
                                    <td>
                                        <span
                                            class="job-status"
                                            [class]="group.key === ELIGIBLE_GROUP_KEY || childLot.canBeMigrated ? 'job-status-eligible' : 'job-status-ineligible'"
                                        >
                                            {{ LOT_JOB_STATUS_ENUM[childLot.jobStatus] }}
                                        </span>
                                    </td>
                                    @if (group.key === INELIGIBLE_GROUP_KEY) {
                                        <td>
                                            @for (reason of getDisplayReasons(childLot); track reason) {
                                                <div class="eligibility-reason">{{ reason }}</div>
                                            }
                                        </td>
                                    }
                                    @if (group.key !== INELIGIBLE_GROUP_KEY) {
                                        <td></td>
                                    }
                                </tr>
                            }
                        }
                    </tbody>
                </cb-table>
            </mat-expansion-panel>
        }
    </mat-accordion>
    @if (groups.length < 1) {
        <p>No lots available for migration.</p>
    }
</div>
